module.exports = __webpack_public_path__ + "static/media/otherTruck.e91af419.svg";